import types from '../../../../../../../actions/types';

export function saveGame(data, resolve, reject) {
    return {type: types.SAVE_GAME.REQUEST, payload: {data, resolve, reject}};
}

export function getGame(id) {
    return {type: types.GET_GAME.REQUEST, payload: {id}};
}



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/edit/modules/game-edit-actions.js